/// <reference path="../walkinManager.module.ts" />
/// <reference path="../../../components/models/meevo.model.custom.ts" />
/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.WalkinManager.AddToWaitlist {
    class WalkinManagerSelectedServicesModalController {
        static $inject = ['$mdDialog', 'selectedService'];
        public selectedService: any;
        protected mdDialog: ng.material.IDialogService;

        constructor(
            protected $mdDialog: ng.material.IDialogService,
            selectedService: any
        ) {
            this.selectedService = selectedService;
            this.mdDialog = $mdDialog;
           
        }

        close() {
            this.mdDialog.hide();
        }


    }

    angular.module('meevo.plugins.walkinManager')
        .controller('meevo.plugins.walkinManager.addToWaitlist.WalkinManagerSelectedServicesModalController', WalkinManagerSelectedServicesModalController);
}
